import { ChevronRight, SlidersHorizontal } from 'lucide-react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './tuning-entry-row.module.scss';

const styles = {
  root: pickCss(css, css.root),
  button: pickCss(css, css.button),
  body: pickCss(css, css.body),
  title: pickCss(css, css.title),
  subtitle: pickCss(css, css.subtitle),
  chevron: pickCss(css, css.chevron),
  icon: pickCss(css, css.icon),
};

type TuningEntryRowProps = {
  onClick: () => void;
};

/**
 * TuningEntryRow — pen `tunEntry` / `tunLink`. Opens the global
 * recommendation-tuning screen (hashtag weights for all days).
 */
export const TuningEntryRow = ({ onClick }: TuningEntryRowProps) => (
  <div className={styles.root()}>
    <button
      className={styles.button()}
      data-testid="open-recommendation-tuning"
      onClick={onClick}
      type="button"
    >
      <SlidersHorizontal
        aria-hidden="true"
        className={styles.icon()}
        size={14}
      />
      <span className={styles.body()}>
        <span className={styles.title()}>Recommendation tuning</span>
        <span className={styles.subtitle()}>
          Hashtag weights · applies to all days
        </span>
      </span>
      <ChevronRight aria-hidden="true" className={styles.chevron()} size={13} />
    </button>
  </div>
);
